import React, { useState } from 'react';
import { graphql } from 'gatsby';
import { H2, H5, Normal } from 'components/Core/Typography';
import { STIcon } from 'components/Brand/Icons/STIcon';
import Slider from 'react-slick';
import FeatureWheel from './FeatureWheel';
import { FeatureWheelSectionContainer } from './styles';
import ContentfulCallToAction from 'components/Contentful/ContentfulCallToAction';
import HoverableHyperLink from 'components/Core/HyperLink/HoverableHyperLink';
import { useStaticQuery } from 'gatsby';

const FeatureWheelSection = ({ title, features, ...otherProps }) => {
  const [selIndex, setSelIndex] = useState(0);
  const [nav1, setNav1] = useState(null);
  const [nav2, setNav2] = useState(null);

  const callToAction = useStaticQuery(graphql`
    query {
      contentfulCallToAction(
        internalName: { eq: "Get Demo CTA - Modal | Request a personalized demo" }
      ) {
        ...CallToAction
      }
    }
  `).contentfulCallToAction;

  const iconSliderSetting = {
    dots: false,
    infinite: true,
    centerMode: true,
    centerPadding: '0',
    slidesToShow: 3,
    arrows: false,
  };

  const contentSliderSetting = {
    dots: true,
    infinite: true,
    centerMode: true,
    centerPadding: '0',
    slidesToShow: 1,
    prevArrow: (
      <div>
        <STIcon type="icon-slider-arrow-right" />
      </div>
    ),
    nextArrow: (
      <div>
        <STIcon type="icon-slider-arrow-right" />
      </div>
    ),
  };

  return (
    <FeatureWheelSectionContainer {...otherProps}>
      <div className="feature-wheel--desktop-content-container">
        <div className="feature-wheel--content-container">
          <H2 className="feature-wheel--content-title">{title}</H2>
          <div className="feature-wheel--content-content">
            <div className="feature-wheel--content-copy">
              <H5 className="feature-wheel--content-feature-title">{features[selIndex].title}</H5>
              <Normal className="feature-wheel--content-feature-description">
                {features[selIndex].description}
              </Normal>
            </div>
            <div className="feature-wheel--ctas">
              <ContentfulCallToAction {...callToAction} />
              <HoverableHyperLink
                className="feature-wheel--content-feature-link"
                href={features[selIndex].link}
                text={`See the feature${' '}`}
                iconColor="var(--neutral-7)"
              />
            </div>
          </div>
          <div className="feature-wheel--arrow-container">
            <div
              className="feature-wheel--arrow-item arrow-prev"
              onClick={() =>
                setSelIndex(selIndex > 0 ? selIndex - 1 : selIndex + features.length - 1)
              }
            >
              <STIcon type="icon-slider-arrow-right" />
            </div>
            <div
              className="feature-wheel--arrow-item arrow-next"
              onClick={() =>
                setSelIndex(
                  selIndex < features.length - 1 ? selIndex + 1 : selIndex + 1 - features.length
                )
              }
            >
              <STIcon type="icon-slider-arrow-right" />
            </div>
          </div>
        </div>
        <div className="feature-wheel--wheel-container">
          <FeatureWheel
            features={features}
            selIndex={selIndex}
            onItemClick={index => setSelIndex(index)}
          />
        </div>
      </div>

      <div className="feature-wheel--mobile-content-container">
        <H2 className="feature-wheel--content-title">{title}</H2>
        <div className="feature-wheel--wheel-slick">
          <Slider
            className="feature-wheel--icon-slider"
            asNavFor={nav2}
            ref={nav => setNav1(nav)}
            {...iconSliderSetting}
          >
            {features &&
              features.length > 0 &&
              features.map((feature, index) => (
                <div className="feature-wheel--icon-slider-item" key={index}>
                  <img
                    className="feature-wheel--item-icon"
                    src={feature.icon}
                    alt={feature.title}
                  />
                </div>
              ))}
          </Slider>

          <Slider
            className="feature-wheel--content-slider"
            asNavFor={nav1}
            ref={nav => setNav2(nav)}
            {...contentSliderSetting}
          >
            {features &&
              features.length > 0 &&
              features.map((feature, index) => (
                <div className="feature-wheel--content-slider-item" key={index}>
                  <H5 className="feature-wheel--content-feature-title">{feature.title}</H5>
                  <Normal className="feature-wheel--content-feature-description">
                    {feature.description}
                  </Normal>
                  <div className="feature-wheel--ctas">
                    <ContentfulCallToAction {...callToAction} />
                    <a className="feature-wheel--content-feature-link" href={feature.link}>
                      See the feature
                    </a>
                  </div>
                </div>
              ))}
          </Slider>
        </div>
      </div>
    </FeatureWheelSectionContainer>
  );
};

export default FeatureWheelSection;
